import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Auth\PinBasedRegistrationController::form
 * @see app/Http/Controllers/Auth/PinBasedRegistrationController.php:21
 * @route '/admin/pin-verification'
 */
export const form = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: form.url(options),
    method: 'get',
})

form.definition = {
    methods: ["get","head"],
    url: '/admin/pin-verification',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Auth\PinBasedRegistrationController::form
 * @see app/Http/Controllers/Auth/PinBasedRegistrationController.php:21
 * @route '/admin/pin-verification'
 */
form.url = (options?: RouteQueryOptions) => {
    return form.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\PinBasedRegistrationController::form
 * @see app/Http/Controllers/Auth/PinBasedRegistrationController.php:21
 * @route '/admin/pin-verification'
 */
form.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: form.url(options),
    method: 'get',
})
/**
* @see \App\Http\Controllers\Auth\PinBasedRegistrationController::form
 * @see app/Http/Controllers/Auth/PinBasedRegistrationController.php:21
 * @route '/admin/pin-verification'
 */
form.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: form.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Auth\PinBasedRegistrationController::verify
 * @see app/Http/Controllers/Auth/PinBasedRegistrationController.php:29
 * @route '/admin/verify-pin'
 */
export const verify = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: verify.url(options),
    method: 'post',
})

verify.definition = {
    methods: ["post"],
    url: '/admin/verify-pin',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Auth\PinBasedRegistrationController::verify
 * @see app/Http/Controllers/Auth/PinBasedRegistrationController.php:29
 * @route '/admin/verify-pin'
 */
verify.url = (options?: RouteQueryOptions) => {
    return verify.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\PinBasedRegistrationController::verify
 * @see app/Http/Controllers/Auth/PinBasedRegistrationController.php:29
 * @route '/admin/verify-pin'
 */
verify.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: verify.url(options),
    method: 'post',
})
const pin = {
    form: Object.assign(form, form),
verify: Object.assign(verify, verify),
}

export default pin